/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext, useState } from 'react';
import Media from 'react-media';
import { makeStyles } from '@material-ui/core/styles';

import {
    bool, object, string, shape, array, arrayOf, number, func,
} from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import MobileFoodAddToCart from './Mobile/MobileFoodAddToCart';

import DesktopFoodAddToCart from './Desktop/DesktopFoodAddToCart';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import PDPSeoSchemaOutOfStock from '../GraphqlProductSeoSchema/PDPSeoSchemaOutOfStock';
import { getProductUnAvailable } from '../../../../../../state/ducks/App/App-Selectors';

const useStyle = makeStyles((theme) => ({
    container: {
        paddingTop: '16px',
        [theme.breakpoints.down('600')]: {
            width: 'calc(100% - 32px)',
            margin: '0px auto 0px',
            paddingTop: '12px',
        },
    },
    plaContainer: {
        padding: '0px',
        '& > div:first-child': {
            paddingBottom: '16px',
            '@media screen and (max-width:768px)': {
                padding: '16px 0px',
            },
            '@media screen and (max-width:600px)': {
                padding: '16px 0px 0px',
            },
        },
        '@media screen and (max-width:600px)': {
            width: '100%',
        },
        '& button': {
            minWidth: '100% !important',
        },
    },
}));
const GraphqlFoodAddToCart = ({
    isAddToCartEnabled,
    selectedItemId,
    brandId,
    partNumber,
    categoryId,
    categoryPath,
    categoryName,
    subscription,
    subscriptionDetails,
    productType,
    totalProductSelected,
    maxComponents,
    cyoSelectedComponents,
    disableAddToCart,
    personalizedData,
    isPersonalizable,
    product,
    presentation_family,
    addons,
    closeAddonModal,
    handleMiniCartModalClick,
    quantity,
    isBandItemSelected,
    handleMobileAgeVerification,
    isMobile,
    hasWine,
    isPassportBundleProduct,
    movieSelected,
    productDemandType,
    deliveryMethod,
    isTryMeProduct,
    deliveryIndicator,
    selectedSku,
    selectAddons,
    isBYOProduct,
    atcCallBack,
    content,
    isPdpRedesignEnabled,
    isPdpRedesignSkuEnabled,
    isPlaRedesignEnabled,
    showAddToCart,
    addToCartPriceShow,
    isCaDelivery,
    isDeliverCharges,
    setProductQuantity,
}) => {
    // use for the open the personalization model for multiple lines text
    const classes = useStyle();
    const [open, setOpen] = useState(false);
    const brand = useSelector(getBrand);
    const location = useLocation();
    const productUnAvailable = useSelector(getProductUnAvailable);
    const { featureFlags = {} } = useContext(CrossMerch);
    const [personalizationData, setPersonalization] = useState(personalizedData);
    const pdpInlineAddon = featureFlags['is-inline-addons-pdp-enabled'] &&  selectAddons.length;
    const cartIconLabel = featureFlags['cart-icon-label']?.label || 'Cart';
    const setPersonalizationState = (newState) => {
        setPersonalization({
            personalization: newState,
        });
    };

    const closePersonalizationModal = () => {
        setOpen(false);
    };

    const removedSpecialChars = (text) => {
        if (text) {
            // allowing on alphanumeric, spaces, new line and "?","!", "-", ",", "."
            return text?.replace?.(/[^a-zA-Z0-9\s/\\!/\\./\\,/\\?/\\-]/g, '');
        }
        return '';
    };

    const handlePersonalizationTextFieldChange = (e) => {
        const stateCopy = personalizationData;
        if (e.target.value.length <= stateCopy.personalization.lineState[Number(e.target.name)].maxChars) {
            stateCopy.personalization.lineState[e.target.name].lineText = removedSpecialChars(e.target.value);
        }
        setPersonalization({
            personalization: stateCopy.personalization,
        });
    };

    const getAddons = () => {
        const addonsComponents = [];
        selectAddons?.forEach((addon) => {
            const addonItem = {
                brandCode: brandId,
                productCode: addon.partNumber,
                componentType: 'ADDON',
                productId: addon.legacyId,
                quantity: addon?.qty,
            };
            addonsComponents.push(addonItem);
        });
        return addonsComponents;
    };
    const wineFlag = selectAddons?.some((item) => item?.ageVerifyFlag);
    const renderTotalOrderPrice = (priceShowing) => {
        let price = priceShowing?.prices?.[0]?.value;
        if (priceShowing?.prices?.[0] && priceShowing?.prices?.[1]) {
            if (priceShowing.prices[0]?.value > priceShowing.prices[1]?.value) {
                price = priceShowing?.prices?.[1]?.value;
            } else {
                price = priceShowing?.prices?.[0]?.value;
            }
        }
        return price;
    };

    const getSalePrice = (prices) => {
        const salePrice = prices?.filter((price) => price?.type === 'sale');
        if (salePrice?.length > 0) {
            return salePrice?.[0]?.value;
        }
        return 0;
    };
    const generateProductTotal = () => {
        const subTotalPrice = renderTotalOrderPrice(selectedSku);
        const priceArray = (selectAddons || []).map((addon) => getSalePrice(addon.prices) * addon.qty);
        priceArray.push(subTotalPrice || 0);
        return (priceArray || []).reduce((a, b) => a + b, 0);
    };

    const handleQuantity = () => {
        const qtyArray = (selectAddons || []).map((addon) => addon.qty);
        return (qtyArray || []).reduce((a, b) => a + b, 0);
    };

    const renderFoodAddToCart = (mobile) => {
        let response;
        if (mobile) {
            response = (
                <MobileFoodAddToCart
                    isAddToCartEnabled={isAddToCartEnabled}
                    selectedItemId={selectedItemId}
                    brandId={brandId}
                    partNumber={partNumber}
                    categoryId={categoryId}
                    categoryPath={categoryPath}
                    categoryName={categoryName}
                    subscription={subscription}
                    subscriptionDetails={subscriptionDetails}
                    productType={productType}
                    totalProductSelected={totalProductSelected}
                    maxComponents={maxComponents}
                    cyoSelectedComponents={cyoSelectedComponents}
                    disableAddToCart={disableAddToCart}
                    personalizedData={personalizedData}
                    isPersonalizable={isPersonalizable}
                    product={product}
                    quantity={quantity}
                    handleMiniCartModalClick={handleMiniCartModalClick}
                    presentation_family={presentation_family}
                    isBandItemSelected={isBandItemSelected}
                    handleMobileAgeVerification={handleMobileAgeVerification}
                    isMobile
                    hasWine={pdpInlineAddon ? wineFlag : hasWine}
                    addons={pdpInlineAddon ? getAddons() : addons}
                    isPassportBundleProduct={isPassportBundleProduct || {}}
                    movieSelected={movieSelected}
                    productDemandType={productDemandType}
                    deliveryMethod={deliveryMethod}
                    isTryMeProduct={isTryMeProduct}
                    deliveryIndicatorPDP={deliveryIndicator}
                    featureFlags={featureFlags}
                    selectedSku={selectedSku}
                    open={open}
                    setOpen={setOpen}
                    closePersonalizationModal={closePersonalizationModal}
                    setPersonalizationState={setPersonalizationState}
                    personalizationData={personalizationData}
                    setPersonalization={setPersonalization}
                    handlePersonalizationTextFieldChange={handlePersonalizationTextFieldChange}
                    pdpInlineAddon={pdpInlineAddon || selectAddons.length}
                    price={generateProductTotal()}
                    selectAddons={selectAddons}
                    handleQuantity={handleQuantity()}
                    closeAddonModal={closeAddonModal}
                    isBYOProduct={isBYOProduct}
                    atcCallBack={atcCallBack}
                    content={content}
                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                    isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                    showAddToCart={showAddToCart}
                    cartIconLabel={cartIconLabel}
                    addToCartPriceShow={addToCartPriceShow}
                    isCaDelivery={isCaDelivery}
                    isDeliverCharges={isDeliverCharges}
                    setProductQuantity={setProductQuantity}
                />

            );
        } else {
            response = (
                <DesktopFoodAddToCart
                    isAddToCartEnabled={isAddToCartEnabled}
                    selectedItemId={selectedItemId}
                    brandId={brandId}
                    partNumber={partNumber}
                    categoryId={categoryId}
                    categoryPath={categoryPath}
                    categoryName={categoryName}
                    subscription={subscription}
                    subscriptionDetails={subscriptionDetails}
                    productType={productType}
                    totalProductSelected={totalProductSelected}
                    maxComponents={maxComponents}
                    cyoSelectedComponents={cyoSelectedComponents}
                    disableAddToCart={disableAddToCart}
                    personalizedData={personalizedData}
                    isPersonalizable={isPersonalizable}
                    product={product}
                    presentation_family={presentation_family}
                    addons={pdpInlineAddon ? getAddons() : addons}
                    closeAddonModal={closeAddonModal}
                    // IMP for minicart as it handels it open and close of minicart(NB: not needed in mobile)
                    handleMiniCartModalClick={handleMiniCartModalClick}
                    quantity={quantity}
                    isBandItemSelected={isBandItemSelected}
                    handleMobileAgeVerification={handleMobileAgeVerification}
                    hasWine={pdpInlineAddon ? wineFlag : hasWine}
                    isMobile={isMobile}
                    isPassportBundleProduct={isPassportBundleProduct || {}}
                    movieSelected={movieSelected}
                    productDemandType={productDemandType}
                    deliveryMethod={deliveryMethod}
                    isTryMeProduct={isTryMeProduct}
                    deliveryIndicatorPDP={deliveryIndicator}
                    selectedSku={selectedSku}
                    open={open}
                    setOpen={setOpen}
                    closePersonalizationModal={closePersonalizationModal}
                    setPersonalizationState={setPersonalizationState}
                    personalizationData={personalizationData}
                    setPersonalization={setPersonalization}
                    selectAddons={selectAddons}
                    handlePersonalizationTextFieldChange={handlePersonalizationTextFieldChange}
                    pdpInlineAddon={pdpInlineAddon || selectAddons.length}
                    price={generateProductTotal()}
                    handleQuantity={handleQuantity()}
                    isBYOProduct={isBYOProduct}
                    atcCallBack={atcCallBack}
                    content={content}
                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                    isPdpRedesignSkuEnabled={isPdpRedesignSkuEnabled}
                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                    showAddToCart={showAddToCart}
                    cartIconLabel={cartIconLabel}
                    addToCartPriceShow={addToCartPriceShow}
                    isCaDelivery={isCaDelivery}
                    isDeliverCharges={isDeliverCharges}
                    setProductQuantity={setProductQuantity}
                />
            );
        }
        return response;
    };

    return (
        <Media queries={{
            mobile: '(min-width: 320px) and (max-width: 600px)',
            desktop: '(min-width: 601px)',
        }}
        >
            {(matches) => (
                <div className={`${isPdpRedesignEnabled ? classes.container : ''} ${isPlaRedesignEnabled ? classes.plaContainer : ''}`}>
                    {renderFoodAddToCart(matches.mobile)}
                    {productUnAvailable && (
                        <PDPSeoSchemaOutOfStock
                            brand={brand}
                            partNumber={selectedSku?.partNumber}
                            name={selectedSku?.name}
                            location={location}
                        />
                    )}
                </div>
            )}
        </Media>
    );
};

GraphqlFoodAddToCart.propTypes = {
    categoryId: string,
    partNumber: string,
    selectedItemId: string,
    brandId: string.isRequired,
    subscriptionDetails: shape({
        subscriptionType: string,
        subscriptionDuration: string,
        subscriptionFrequency: string,
        subscriptionDurationKey: string,
    }),
    subscription: shape({
        subscriptionKey: array,
        subscriptionIndefinite: string,
        subscriptionType: array,
        implementProductSubscription: bool,
        viewSubscription: bool,
        isTypeDiscovery: bool,
        subscriptionCheckbox: bool,
    }),
    productType: string,
    totalProductSelected: number,
    maxComponents: number,
    cyoSelectedComponents: array,
    product: object.isRequired,
    presentation_family: string,
    disableAddToCart: bool,
    personalizedData: shape({
        personalizationType: string,
        personalizationLines: arrayOf({
            perAttributeValue: string,
        }),
    }),
    isPersonalizable: bool,
    isAddToCartEnabled: bool,
    categoryPath: string,
    categoryName: string,
    addons: arrayOf(shape({
        brandCode: string,
        productCode: number,
        componentType: string,
        productId: string,
        quantity: number,
    })),
    isBandItemSelected: bool,
    closeAddonModal: func,
    handleMiniCartModalClick: func,
    quantity: string,
    handleMobileAgeVerification: func,
    isMobile: bool,
    hasWine: bool,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    movieSelected: shape({
        error: bool,
        skuSelected: shape({
            sku: string.isRequired,
            sku_description: string.isRequired,
            sku_price: number.isRequired,
        }),
    }),
    productDemandType: string,
    deliveryMethod: string.isRequired,
    isTryMeProduct: bool,
    deliveryIndicator: string.isRequired,
    selectedSku: shape({
        id: string,
    }),
    selectAddons: array,
    isBYOProduct: bool,
    atcCallBack: func,
    content: object,
    isPdpRedesignEnabled: bool,
    isPdpRedesignSkuEnabled: bool,
    isPlaRedesignEnabled: bool,
    showAddToCart: bool,
    addToCartPriceShow: object,
    isCaDelivery: bool,
    isDeliverCharges: bool,
    setProductQuantity: func,
};

GraphqlFoodAddToCart.defaultProps = {
    selectedItemId: null,
    subscriptionDetails: {},
    subscription: {},
    productType: '',
    totalProductSelected: 0,
    maxComponents: null,
    cyoSelectedComponents: [],
    disableAddToCart: false,
    personalizedData: {},
    isPersonalizable: false,
    presentation_family: 'food',
    categoryPath: '',
    categoryName: '',
    addons: [],
    closeAddonModal: () => { },
    handleMiniCartModalClick: () => { },
    quantity: '1',
    isBandItemSelected: true,
    categoryId: '',
    partNumber: '',
    isAddToCartEnabled: false,
    handleMobileAgeVerification: () => { },
    isMobile: false,
    hasWine: false,
    isPassportBundleProduct: {},
    movieSelected: null,
    productDemandType: null,
    isTryMeProduct: false,
    selectedSku: {},
    selectAddons: [],
    isBYOProduct: false,
    atcCallBack: () => {},
    content: {},
    isPdpRedesignEnabled: false,
    isPdpRedesignSkuEnabled: false,
    isPlaRedesignEnabled: false,
    showAddToCart: true,
    addToCartPriceShow: null,
    isCaDelivery: false,
    isDeliverCharges: false,
    setProductQuantity: () => {},
};

export default GraphqlFoodAddToCart;
